import { viewport } from '../utils/viewport';
import { clamp } from '../utils/math';

let gradients: HTMLElement[] = [];

function onMousemove(event: MouseEvent) {
    if (!matchMedia('(hover: none)').matches) {
        gradients.forEach((el) => {
            el.style.transform = `translate3d(${event.clientX - viewport.width / 2}px, ${clamp(
                (event.clientY - viewport.height / 2) * 0.3,
                -50,
                50,
            )}px, 0)`;
        });
    }
}

function init(container: HTMLElement | Document = document) {
    gradients = Array.from(container.querySelectorAll<HTMLElement>('.js-zeno-2-gradient'));
    document.addEventListener('mousemove', onMousemove);
}

function destroy() {
    document.removeEventListener('mousemove', onMousemove);
    gradients = [];
}

const _module = { init, destroy };

export default _module;
